import { ReactNode } from "react";

export interface Integration {
  id: string;
  name: string;
  icon: ReactNode;
}

export enum Step {
  FIRST,
  SECOND
}

export enum IntegrationId {
  GA = "GA",
  HUBSPOT = "HUBSPOT",
  CODEBOX = "CODEBOX",
  ZILLOW = "ZILLOW",
  APARTMENTS_COM = "APARTMENTS_COM"
}
